import React from 'react';

import { useIpc } from '~src/utils/ipc-utils';

export const useOutSideIframeClick = (
  onOutsideClick: () => void,
  dependencies: ReadonlyArray<any> = []
) => {
  const ipc = useIpc();
  React.useEffect(() => {
    const stopListening = ipc.listen(({ name }) => {
      if (name === 'outside_click') {
        onOutsideClick();
      }
    });

    return stopListening;
  }, dependencies);
};

export const useFocus = () => {
  const [isFocused, setIsFocused] = React.useState<boolean>(false);

  const focusProps = {
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
  };

  return {
    focusProps,
    isFocused,
  };
};

export type FocusResult = ReturnType<typeof useFocus>;
